import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { UserInfo } from '@games/types';
import { getUserInfo, storeUserInfo } from '@games/api';

interface AuthSliceState {
  user: UserInfo | null;
}

const initialState: AuthSliceState = {
  user: getUserInfo(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<UserInfo | null>) {
      state.user = action.payload;
      storeUserInfo(action.payload);
    },
  },
});

export const { setUser: setAuthUser } = authSlice.actions;
export const { reducer: authReducer } = authSlice;
export const selectAuthUser = (state: { auth: AuthSliceState }) => {
  const authState: AuthSliceState = state.auth;
  return authState.user;
}
